'use strict';

import { slideDown, slideToggle, slideUp } from "../functions.js";

document.addEventListener('DOMContentLoaded', () => {
  // btn other bonus
  const btnBrandBonus = document.querySelector('.brand__button');
  const brandBonus = document.querySelectorAll('.brand-bonus--hidden');

  if(btnBrandBonus) {
    btnBrandBonus.addEventListener('click', () => {
      brandBonus.forEach((item) => {
        slideUp(btnBrandBonus);
        slideDown(item);
      });
    });
  }

  // table contents
  const btnTableContents = document.querySelector('.table-contents__button');

  if(btnTableContents) {
    btnTableContents.addEventListener('click', (e) => {
      if(document.body.clientWidth < 1024) {
        e.target.classList.toggle('table-contents__button--opened');
        slideToggle(e.target.nextElementSibling);
      }
    });
  }

  window.addEventListener('resize', () => {
    if(document.body.clientWidth >= 1024) {
      if(btnTableContents) {
        btnTableContents.classList.remove('table-contents__button--opened');
        btnTableContents.nextElementSibling.removeAttribute('style');
      }
    }
  });

  const linksTableContents = document.querySelectorAll('.table-contents__link');
  const header = document.querySelector('header');

  if(linksTableContents) {
    linksTableContents.forEach((item) => {
      item.addEventListener('click', (e) => {
        e.preventDefault();
        const link = item.getAttribute('href');
        const blockID = link.substring(link.indexOf('#'));
        const elID = document.querySelector(blockID);
        const topOffset = header.offsetHeight + 24;
        const elementPosition = elID.getBoundingClientRect().top;
        const offsetPosition = elementPosition - topOffset;

        window.scrollBy({
          top: offsetPosition,
          behavior: 'smooth'
        });
      });
    });
  }

});